module.exports = __webpack_public_path__ + "static/media/ror-scaffold.78765313.png";